import { render, staticRenderFns } from "./NewTopic.vue?vue&type=template&id=251c7254&"
import script from "./NewTopic.js?vue&type=script&lang=js&"
export * from "./NewTopic.js?vue&type=script&lang=js&"
import style0 from "./NewTopic.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports